/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export enum BannerAlertStyleType {
    ERROR = "alert-danger",
    WARNING = "alert-warning",
    SUCCESS = "alert-success",
    INFO = "alert-info"
}
